import moment from 'moment'

import { logger } from 'utils/logger'

export const getTime = dateTime => {
    try {
        return moment(dateTime).format('h:mm a')
    } catch (error) {
        logger.error({
            msg: 'error in getting time : getTime',
            error,
        })
    }
}

export const getTimeForChatMessages = dateTime => {
    try {
        return moment(dateTime).format('h:mm')
    } catch (error) {
        logger.error({
            msg: 'error in getting time : getTimeForChatMessages',
            error,
        })
    }
}
